import { format } from 'date-fns';
import { useEffect, useRef, useState } from 'react';
import { Stack, Typography } from '@mui/material';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { LanguageField, locales } from '../../features/common';

export interface DateProps {
  formatDate: string;
  language: LanguageField;
}

export default function DateComponent({ formatDate, language }: DateProps) {
  const ref = useRef<NodeJS.Timeout>();
  const [date, setDate] = useState(
    format(new Date(), formatDate, {
      locale: locales[language],
    }),
  );

  useEffect(() => {
    ref.current = setInterval(() => {
      setDate(
        format(new Date(), formatDate, {
          locale: locales[language],
        }),
      );
    }, 1000);
    return () => clearInterval(ref.current);
  }, [formatDate, language]);

  return (
    <Stack
      alignItems="center"
      color="primary.contrastText"
      direction="row"
      gap={0.5}
    >
      <CalendarMonthIcon fontSize="small" />
      <Typography variant="body1">{date}</Typography>
    </Stack>
  );
}
